import { loginByUserInfo, userInfo, getPermissions } from '../../interface'

const login = {
    state: {
        username: sessionStorage.getItem('USERNAME'),
        role: '',
        introduce: '',
        county: '',
        newrouter: [],
        permissions: [],
        permissionsList: [],
    },
    mutations: {
        SET_USERNAME: (state, username) => {
            state.username = username;
        },
        SET_ROLE: (state, role) => {
            state.role = role;
        },
        SET_INTRODUCE: (state, introduce) => {
            state.introduce = introduce;
        },
        SET_NEWROUER: (state, newrouter) => {
            state.newrouter = newrouter;
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions;
        },
        SET_PERMISSIONS_LIST: (state, permissionsList) => {
            state.permissionsList = permissionsList;
        },
        GET_PERMISSIONS_LIST: (state) => {
            return state.permissionsList;
        },
        SET_COUNTY: (state, county) => {
            state.county = county;
        },
    },
    actions: {
        Logins({ commit }, info) {
            return new Promise((resolve, reject) => {
                let data = {};
                //   loginByUserInfo.map(function (item) { //获取所以用户信息
                // 	console.log(1111111,item);
                // 	if(info.username === item.username || info.pew === item.pew){
                // 		commit('SET_USERNAME',item.username);  //将username和role进行存储
                // 		sessionStorage.setItem('USERNAME', item.username); //存入 session 
                // 		commit('SET_ROLE',item.role);
                // 		sessionStorage.setItem('ROLE', item.role);
                // 		return data={username:item.username,introduce:item.introduce};
                // 	}else{
                // 		return data;
                // 	}
                // });  	
                loginByUserInfo(info).then(res => {
                    console.log(res)
                    if (res.level) {
                        commit('SET_USERNAME', res.username || '');  //将username和role进行存储
                        sessionStorage.setItem('USERNAME', res.username || ''); //存入 session 
                        commit('SET_ROLE', 'A');
                        sessionStorage.setItem('ROLE', 'A');
                    } else {
                        alert(res.msg);
                    }

                })
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        },
        UserInfo({ commit }, info) {
            return new Promise((resolve, reject) => {
                let data = {};
                userInfo(info).then(res => {
                    data = res;
                    sessionStorage.setItem('sys_admin', data.sys_admin);
                    sessionStorage.setItem('have_perssions', JSON.stringify(data.permission_codes))
                    sessionStorage.setItem('increamentPermission', data.increamentPermission)
                    // console.error(data);
                    // console.log('data', data);
                    commit('SET_COUNTY', data.county || "");


                    if (!login.state.role) {
                        // commit('SET_USERNAME', res.username || '');  //将username和role进行存储
                        // sessionStorage.setItem('USERNAME', res.username || ''); //存入 session 
                        // commit('SET_ROLE', 'A');
                        // sessionStorage.setItem('ROLE', 'A');
                    } else {
                        // console.log('userInfo: ', login)
                    }
                })

                resolve(data);

            }).catch(error => {

            })
        },
        Roles({ commit }, newrouter) {
            return new Promise((resolve, reject) => {
                commit('SET_NEWROUER', newrouter); //存储最新路由
                resolve(newrouter);
            }).catch(error => {
                reject(error);
            });
        },
        Permissions({ commit }, router) {
            return new Promise((resolve, reject) => {
                // console.log(3333, router);
                getPermissions().then(res => {
                    // console.log(res);
                    resolve(res);
                })
            }).catch(error => {
                reject(error);
            });
        },
        Set_Permissions({ commit }, permissions) {
            return new Promise((resolve, reject) => {
                commit('SET_PERMISSIONS', permissions);
                resolve(permissions);
            }).catch(error => {
                reject(error);
            });
        },
        Get_Permissions({ commit }, permissions) {
            return new Promise((resolve, reject) => {
                // resolve(login.state.permissionsList);
                getPermissions().then(res => {
                    resolve(res);
                })
            }).catch(error => {
                reject(error);
            });
        },
        Logout({ commit, state }) {
            return new Promise((resolve, reject) => {

                commit('SET_USERNAME', '');
                commit('SET_ROLE', '');
                commit('SET_NEWROUER', []);
                location.reload();
                sessionStorage.removeItem('USERNAME');
                sessionStorage.removeItem('ROLE');
                resolve();
            }).catch(error => {
                reject(error);
            });
        },

        SetPermissionsList({ commit }, permissionsList) {
            return new Promise((resolve, reject) => {
                commit('SET_PERMISSIONS_LIST', permissionsList)
                resolve(permissionsList);
            }).catch(error => {
                reject(error);
            });
        }

    }
}
export default login;